<template>
  <dl class="unstyled-list" :class="$style.price">
    <template v-for="(price, client) in prices">
      <dt :key="`${client}-dt`">
        <v-tooltip v-if="price.hasSale || price.isOutlet" top color="error">
          <template #activator="{ on, attrs }"
            ><span class="d-flex align-center" v-bind="attrs" v-on="on">
              <IconSelect icon="flag" class="mr-2" :class="$style.saleIcon" />
            </span>
          </template>
          <span>{{
            price.hasSale ? $t('product.saleIconDealerprice') : $t('product.saleIconOutlet')
          }}</span>
        </v-tooltip>
        <DiscountBadge v-show="price.discountText" :discount="price.discountText" />
        <BrandLogoRef
          v-for="logo in price.brands"
          v-show="showBrand"
          :key="logo"
          :brand="`${logo}-signet`"
          :class="[$style.brand, { 'ml-2': price.discountText }]"
        />
        <span class="visually-hidden">{{
          price.brands.map(logo => ucFirst(logo)).join(', ')
        }}</span>
      </dt>
      <dd
        :key="`${client}-dd`"
        :class="{ [$style.zzca]: price.zzca || price.hasSale || price.isOutlet }"
      >
        <del v-show="price.zzca">{{ price.zzca }}</del
        ><span>{{ price.formatted }}</span>
      </dd>
    </template>
  </dl>
</template>

<script>
import BrandLogoRef from '@/js/components/Shared/BrandLogoRef.vue'
import ProductGroupPricesMixin from '@/js/mixins/product-group-prices-mixin.js'
import DiscountBadge from '@/js/components/Shared/Product/DiscountBadge.vue'
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'BrandPrices',
  components: {
    BrandLogoRef,
    DiscountBadge,
    IconSelect,
  },
  mixins: [ProductGroupPricesMixin],
  props: {
    groupPrices: {
      type: Object,
      default: () => ({}),
    },
    showBrand: {
      type: Boolean,
      default: true,
    },
    translationKey: {
      type: String,
      default: '',
    },
    // groupPricesFormatted: {
    //   type: Object,
    //   default: () => ({}),
    // },
  },
  computed: {
    prices() {
      return this.formatGroupPrices(this.groupPrices, this.translationKey)
    },
  },
  methods: {
    ucFirst(text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
  },
}
</script>

<style lang="scss" module>
.brand {
  // width: 8rem;
  // min-width: 3rem;
  height: 1.25rem;
}

.price {
  @media screen and (max-width: map-get($grid-breakpoints, 'md')) {
    // min-width: 0;
    padding: 0.5rem 0;

    text-align: right;
  }
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: minmax(max-content, 100%) minmax(max-content, 3rem);
  gap: 0.5rem;

  font-weight: var(--font-weight-medium);
  font-size: 1.125rem;
  font-family: var(--font-mono);
  text-align: right;

  dt {
    display: flex;
    align-items: center;
    align-self: center;
    justify-self: end;
  }

  dd {
    display: flex;
    flex-direction: column;
    align-self: center;
  }
}

.zzca {
  del {
    font-size: 0.85rem;
    line-height: 1;
    text-decoration: line-through;
    text-decoration-color: var(--error);
  }

  span {
    color: var(--error);
  }
}

.saleIcon {
  width: 16px;
  height: 16px;

  color: var(--error);

  vertical-align: text-bottom;
}
</style>
